import { PDFViewerTool } from '@progress/kendo-react-pdf-viewer';
// eslint-disable-next-line import/no-cycle
import { NetWealthOptions } from '../models/Client';
import { NetWealthType, UserOfficeCountries } from './enums';

export const kellyPartnersPassportAppName = 'Kelly+Partners Passport';
export const mcProgressAppName = 'McProgress';
export const betterOffAppName = 'BetterOff';
export const helmetTitle = 'KELLY+PARTNERS';
export const kpCommunityFeed = 'kp-community';
export const betterOffCommunityFeed = 'betterOff-community';

export const prodEnvironments = ['production', 'mcprod', 'boprod'];

// Urls
export const protectedFallbackPageUrl = '/fallback';
export const bbocWelcomePageUrl = '/be-better-off-challenge';
export const bbocProfilePageUrl = '/profile';
export const bbocQuestionsPageUrl = '/questions';
export const bbocQuestionPageUrl = `${bbocQuestionsPageUrl}/:id`;
export const bbocResultPageUrl = '/result';
export const loginPageUrl = '/';
export const signUpPageUrl = '/register';
export const forgotPasswordPageUrl = '/forgot-password';
export const resetPasswordPageUrl = '/reset-password';
export const dashboardPageUrl = '/dashboard';
export const userProfilePageUrl = '/user-profile';
export const podcastListPageUrl = '/podcast';
export const podcastItemPageUrl = `${podcastListPageUrl}/:itemId`;
export const libraryPageUrl = '/library';
export const bookPageUrlRoot = '/books';
export const bookPageUrl = `${bookPageUrlRoot}/:bookId`;
export const setupAlertPageUrl = `/setup-alert`;
export const progressProgramPageUrl = '/progress-program';
export const invoicesPageUrl = '/invoices'; // Should keep this as it is used in API invoice push notification
export const flightPlanPageUrl = '/flight-plan';
export const eventPageUrl = '/event';
export const eventSessionPageUrl = '/event-session';
export const paymentConfirmationPageUrl = '/payment-confirmation';
export const biometricLoginSetupPageUrl = '/biometric-login-setup';
export const notificationsCentrePageUrl = '/notifications';
export const myHealthPageUrl = '/my-health';
export const investmentPortfolioPageUrl = '/investment-portfolio';
export const myGoalsPageUrl = '/my-goals';
export const chatPageUrlRoot = '/chat';
export const chatPageUrl = `${chatPageUrlRoot}/:channelId`;
export const publicClientJoinPageUrl = '/join';
export const publicClientTypeSelectionPageUrl = '/client-type-selection';
export const publicClientBasicInfoPageUrl = '/my-basic-information';
export const publicClientFamilyPageUrl = '/my-family';
export const publicClientEntitiesPageUrl = '/my-entities';
export const publicClientInterestsPageUrl = '/my-interests';
export const publicClientReviewPageUrl = '/my-profile-review';
export const publicClientCompletionPageUrl = '/my-profile-completion';
export const documentVaultPageUrl = '/document-vault';
export const documentUploadPageUrl = '/document-upload';
export const documentViewPageUrl = '/document-view';
export const documentVaultResetPinPageUrl = '/reset-doc-vault-pin';
export const documentVaultPinSetupSuccessfulPageUrl = '/document-vault-pin-setup-successful';
export const fvaScorePageUrl = '/fva-score';
export const atoSmartDocsPageUrl = '/ato-smart-docs';
export const deleteAppAccountPageUrl = '/delete-app-account';
export const userSocialProfileEditPageUrl = '/user-social-profile-edit';
export const userSocialProfileOverviewPageUrl = '/user-social-profile-overview';
export const communityPageUrl = '/community';
export const featureWalkthroughPageUrl = '/feature-walkthrough';
export const eventRegistrationPageUrl = '/event-registration';
export const kpTradingPageUrl = '/kpg-trading';
export const benefitsAndPerksPageUrl = '/benefits-and-perks';
export const benefitsAndPerksDetailsPageUrl = `${benefitsAndPerksPageUrl}/:offerId`;
export const purpleFilePageUrl = '/purple-file';
export const policiesPageUrl = '/policies';
export const eapPageUrl = '/eap';
export const innovationHubPageUrl = '/innovation-hub';
export const purpleFilePersonalFirmGoalsPageUrl = `${purpleFilePageUrl}/personal-firm-goals`;
export const purpleFileAdminChecklistPageUrl = `${purpleFilePageUrl}/admin-checklist`;
export const purpleFileMyPerformancePageUrl = `${purpleFilePageUrl}/my-performance`;
export const purpleFileReadingListsPageUrl = `${purpleFilePageUrl}/reading-lists`;
export const purpleFileMonthlyMeetingsPageUrl = `${purpleFilePageUrl}/monthly-meetings`;
export const purpleFileAnnualCareerPlanPageUrl = `${purpleFilePageUrl}/annual-career-plan`;
export const purpleFileCareerPathwaysPageUrl = `${purpleFilePageUrl}/career-pathways`;
export const purpleFileLearningResourcesPageUrl = `${purpleFilePageUrl}/learning-resources`;
export const purpleFileBookDetailsPageUrl = `${purpleFileReadingListsPageUrl}/:bookId`;
export const balancePodcastPageUrl = '/balance-podcast';
export const balancePodcastDetailsPageUrl = `${balancePodcastPageUrl}/:podcastId`;
export const go1CoursePageUrl = '/courses';
export const go1CourseDetailPageUrl = `${go1CoursePageUrl}/:loId`;
export const funAndFinanceRecapPageUrl = '/fun-finance-recap';
export const funAndFinanceRecapPresentationPageUrl = '/fun-finance-recap/presentations';
export const funAndFinanceRecapDetailsPageUrl = `${funAndFinanceRecapPageUrl}/:contentId`;
export const appPrivacyPolicyPageUrl = '/app-privacy-policy';
export const referralAndCareerPageUrl = '/referral-and-career';

// Referral & Career
export const openRolesEmbedUrlAU = 'https://www.livehire.com/widgets/job-listings/kellypartners/public';
export const openRolesEmbedUrlUS = 'https://www.livehire.com/widgets/job-listings/kellypartnersus/public';
export const openRolesEmbedUrlIE = 'https://www.livehire.com/widgets/job-listings/kellypartnersie/public';

// Url Parameters
export const eventIdUrlParam = 'eventId';
export const eventSessionIdUrlParam = 'eventSessionId';
export const eventSessionDayUrlParam = 'eventSessionDay';
export const readingListUrlParam = 'readingList';
export const progress12ProgramIdUrlParam = 'progress12ProgramId';
export const appNameUrlParam = 'appName';
export const tabMenuUrlParam = 'tab';
export const userIdUrlParam = 'userId';
export const resetEmailUrlParam = 'resetEmail';
export const resetPasswordTokenUrlParam = 'resetPasswordToken';

// External urls
export const feedbackUrl = 'https://survey.hsforms.com/1cM6o8eyrSQyC7svAPK7MbA439fz';
export const kellyPartnersWebsiteUrl = 'https://www.kellypartners.com.au';
export const funfinanceAIWebsiteUrl = 'https://funfinance-app.azurewebsites.net';
export const beBetterOffShowAIWebsiteUrl = 'https://bkwisdom-app.azurewebsites.net';
export const marketingEmail = 'kun.singh@kellypartners.com.au';
export const mainMarketingEmail = 'marketing@kellypartners.com.au';
export const echoRestaurantGoogleMapUrl = 'https://maps.app.goo.gl/gJfESu4J271DEBqT9';
export const henryRestaurantGoogleMapUrl = 'https://maps.app.goo.gl/pcUaPCnRZA1JQ6Yj9';
export const theBreakerGoogleMapUrl = 'https://maps.app.goo.gl/f1cJz3vw3eiXJbd48';
export const asxAnnouncementsUrl = 'https://www.kellypartnersgroup.com.au/asx-announcements';
export const shareForceUrl = 'https://app.shareforce.net/app/sso/315/';
export const eapWebsiteUrl = 'https://eapassist.com.au/';
export const eapCounsellingBookingUrlAU = 'https://eapassist.com.au/booking-form/make-an-appointment/';
export const eapCounsellingBookingUrlUS = 'https://balancebenefits.com/counseling';
export const eapQuizUrl = 'https://www.nhs.uk/every-mind-matters/mental-wellbeing-tips/your-mind-plan-quiz/';
export const secureEmploymentHeroUrl = 'https://secure.employmenthero.com/';
export const PolicyKpPolicyLibraryPayCheckUrlUS =
	'https://login.flex.paychex.com/login_static/UsernameOnly.html?lang=en&downtime=false';

// External file names
export const kpgTradingFormFileName = 'kpg-trading-request-form.pdf';

// External folder container names
export const kpgShareContainer = 'kpg-share';
export const eapContainer = 'employee-assistance-program';
export const readingListsFileContainer = 'reading-lists';
export const balancePodcastRecapSubFolder = 'recap';

export const echoRestaurant = 'Echo Restaurant';
export const henryRestaurant = "Henry's Restaurant";
export const age45OrOlder = '45 or Older';
export const ageUnder45 = 'Under 45';
export const questionFieldName = 'question';
export const otherFieldName = 'other';
export const otherOptionValue = 'other';
export const questionPageUrlRegExp = /^\/questions\/([0-9]+)/;
export const answerSplitCharacter = ';';
export const contactNumberFormatted = '1300 932 584';
export const dragUpToNumber = 5;
export const emailPattern = '^[\\w._%+-]+@[\\w.-]+\\.[a-zA-Z]{2,}$';
export const emailPatternErrorMessage = 'Please enter a valid email address.';
export const passwordPattern = '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{10,50}$'; // Should keep the same as BE. It is 6 by default in BE Identity.
export const passwordPatternErrorMessage = 'Please enter a valid password.';
export const positiveIntegerPattern = '^[1-9]\\d+$';
export const positiveIntegerPatternErrorMessage = 'Please enter a positive integer';
export const allowedEmailDomainsForBetterOffApp = [
	'kellypartners.com.au',
	'kellypartners.com',
	'kudos-international.com',
	'kellypartnerswealth.com.au',
	'kpinvestmentoffice.com.au',
	'kellypartnersfinance.com.au',
	'kellypartners.ie'
];

export const usLabel = 'United States of America';
export const ukLabel = 'United Kingdom';
export const hkLabel = 'Hong Kong';

export const abnMaxLength = 14;
export const acnMaxLength = 11;
export const tfnMaxLength = 11;

export const bottomNavItemCountPerScreen = 5;
export const photoPageSize = 10;
export const feedActivityPageSize = 5;

// July is 6 because months are 0-indexed
export const julyMonthIndex = 6;

// Questions option values
export const commodities = 'commodities';
export const investmentRiskDiversification = 'investmentRiskDiversification';
export const holisticWealthManagement = 'holisticWealthManagement';
export const retirementPreparedness = 'retirementPreparedness';
export const businessSaleProceedsInvesting = 'businessSaleProceedsInvesting';
export const familyCharter = 'familyCharter';
export const enduringGuardianship = 'enduringGuardianship';
export const enduringPowerOfAttorney = 'enduringPowerOfAttorney';
export const intergenerationalWealthPlan = 'intergenerationalWealthPlan';
export const agedCarePlanning = 'agedCarePlanning';
export const businessControl = 'businessControl';
export const smsfControl = 'SMSFControl';
export const philanthropicLegacies = 'philanthropicLegacies';
export const implementationAndAdministrationOfEstatePlans = 'implementationAndAdministrationOfEstatePlans';
export const noneOfAboveOptionValue = 'none';
// Personal and Wealth Net Wealth
export const assets = 'Assets';
export const liabilities = 'Liabilities';
// Assets categories
export const assetCashOrCashEquivalent = 'Cash or cash equivalent';
export const assetProperty = 'Property';
export const assetMotorVehicle = 'Motor Vehicle';
export const assetInvestments = 'Investments';
export const assetPersonalAssets = 'Personal Assets';
// Liability categories
export const liabilityPropertyLoan = 'Property Loan';
export const liabilityInvestments = 'Investments';
export const liabilityLoanBalances = 'Loan balances';
// SubCategories
export const superannuation = 'Superannuation';
export const cashAssetsTypes = ['General Account', 'Savings Account', 'Term Deposit'];
// Share/Trusts Assets Types
export const unitsinlistUnitTrusts = 'Units in list Unit Trusts';
export const sharesinprivatecompanies = 'Shares in private companies';
export const unitsinprivateUnitTrusts = 'Units in private Unit Trusts';
export const shareAssetsTypes = [unitsinlistUnitTrusts, sharesinprivatecompanies, unitsinprivateUnitTrusts];
// Client Types
export const activeType = 'Active';
export const pendingAppUserType = 'PendingAppUser';

const assetCategories: NetWealthOptions[] = [
	assetCashOrCashEquivalent,
	assetProperty,
	assetMotorVehicle,
	assetInvestments,
	assetPersonalAssets
].map((c) => {
	return { text: c, value: c, type: NetWealthType.Asset };
});

const liabilityCategories: NetWealthOptions[] = [
	liabilityPropertyLoan,
	liabilityInvestments,
	liabilityLoanBalances
].map((c) => {
	return { text: c, value: c, type: NetWealthType.Liability };
});

export const netWealthCategories: NetWealthOptions[] = assetCategories.concat(liabilityCategories);

const personalItemsAssetsSubCategories: NetWealthOptions[] = [
	'Furniture',
	'Equipment',
	'Jewellery',
	'Caravan',
	'Jet Ski',
	'Boat',
	'Other'
].map((c) => {
	return { text: c, value: c, category: assetPersonalAssets };
});

const cashOrCashEquivalentSubCategories: NetWealthOptions[] = cashAssetsTypes.map((c) => {
	return { text: c, value: c, category: assetCashOrCashEquivalent };
});

const propertyAssetsSubCategories: NetWealthOptions[] = [
	'Main Residence',
	'Rental Property',
	'Holiday House',
	'Commercial Property'
].map((c) => {
	return { text: c, value: c, category: assetProperty };
});

const motorVehicleAssetsSubCategories: NetWealthOptions[] = ['Family Car', 'Work Car', 'Motor Bike'].map((c) => {
	return { text: c, value: c, category: assetMotorVehicle };
});

const investmentsAssetsSubCategories: NetWealthOptions[] = [
	'Business',
	'Share Portfolio',
	'Shares in listed companies',
	sharesinprivatecompanies,
	unitsinlistUnitTrusts,
	unitsinprivateUnitTrusts,
	'Commercial Loan Asset',
	'Money Owed',
	superannuation,
	'Cryptocurrencies (AUD)'
].map((c) => {
	return { text: c, value: c, category: assetInvestments };
});

const assetsSubCategories: NetWealthOptions[] = cashOrCashEquivalentSubCategories
	.concat(
		propertyAssetsSubCategories,
		motorVehicleAssetsSubCategories,
		investmentsAssetsSubCategories,
		personalItemsAssetsSubCategories
	)
	.map((c) => {
		return { ...c, type: NetWealthType.Asset };
	});

const propertyLoanSubCategories: NetWealthOptions[] = ['Home Loan', 'Rental Property Loan', 'Mortgage'].map((c) => {
	return { text: c, value: c, category: liabilityPropertyLoan };
});

const investmentsLiabilitiesSubCategories: NetWealthOptions[] = [
	'Business Loan',
	'Vendor Loan',
	'Bank Overdraft',
	'Margin Loan'
].map((c) => {
	return { text: c, value: c, category: liabilityInvestments };
});

const loanBalancesSubCategories: NetWealthOptions[] = [
	'Vehicle Finance',
	'Equipment Finance',
	'Credit Card',
	'Tax Office Debt',
	'Other Payables'
].map((c) => {
	return { text: c, value: c, category: liabilityLoanBalances };
});

const liabilitiesSubCategories: NetWealthOptions[] = propertyLoanSubCategories
	.concat(investmentsLiabilitiesSubCategories, loanBalancesSubCategories)
	.map((c) => {
		return { ...c, type: NetWealthType.Liability };
	});

export const netWealthSubCategories: NetWealthOptions[] = assetsSubCategories.concat(liabilitiesSubCategories);

export const personalInsuranceProviders = [
	'AIA Australia',
	'AMP Life',
	'Asteron Life',
	'BT Life',
	'Clearview Life',
	'Comminsure',
	'MLC Life',
	'Neos Life',
	'Noble Oak (PPS Mutual)',
	'OnePath',
	'TAL',
	'Westpac Life',
	'Zurich Life'
];

export const insuranceCoverType = ['Income Protection', 'Life', 'TPD', 'Trauma Cover'];

export const entityContactRoles = [
	'Director',
	'Shareholder',
	'Beneficiary',
	'Trustee',
	'Executive',
	'Unit holder',
	'Member',
	'Partner'
];

export const entityAssociationRoles = ['Shareholder', 'Beneficiary', 'Trustee', 'Unit holder'];

// HowNow Document constants
export const clientTableName = 'Client';
export const entityTableName = 'Entities';
export const clientWealthInsuranceTableName = 'ClientWealthInsurance';

export const superTypes = [
	{ text: 'Retail / APRA', value: 'Retail / APRA' },
	{ text: 'Defined Benefit', value: 'Defined Benefit' },
	{ text: 'SMSF', value: 'SMSF' }
];

export const pensionPayingTypes = [
	{ text: 'Account Based', value: 'Account Based' },
	{ text: 'TTR Pension', value: 'TTR Pension' },
	{ text: 'Lifetime Annuity', value: 'Lifetime Annuity' },
	{ text: 'Fixed Term Annuity', value: 'Fixed Term Annuity' },
	{ text: 'TAP', value: 'TAP' }
];

export const howNowRequestErrorMesageForClient = 'No MYOB client code for client ID';
export const howNowRequestErrorMesageForClientDirector = 'No HowNow token found for director ID';

export const howNowShowErrorMesageToClient = 'Please contact your director to get authorised to upload documents.';

export const auCulture = 'en-AU';
export const usCulture = 'en-US';
export const ukCulture = 'en-GB';
export const hkCulture = 'cn-HK';

export const defaultCurrency = 'AUD';

export const localeCurrencies: { key: string; value: string }[] = [
	{ key: auCulture, value: 'AUD' },
	{ key: usCulture, value: 'USD' },
	{ key: ukCulture, value: 'EUR' },
	{ key: 'en-IN', value: 'INR' },
	{ key: 'fr-FR', value: 'EUR' }
];

export const countryAndIsoCodesForMobileNumber: { country: string; isoCode: string }[] = [
	{ country: UserOfficeCountries.AU, isoCode: 'au' },
	{ country: UserOfficeCountries.US, isoCode: 'us' },
	{ country: UserOfficeCountries.HK, isoCode: 'hk' },
	{ country: UserOfficeCountries.IE, isoCode: 'ie' },
	{ country: UserOfficeCountries.IN, isoCode: 'in' },
	{ country: UserOfficeCountries.PH, isoCode: 'ph' },
	{ country: UserOfficeCountries.UK, isoCode: 'gb' }
];

export const countryToISO2: Record<string, string> = {
	USA: 'us',
	'United States': 'us',
	'United Kingdom': 'gb',
	UK: 'gb',
	'Hong Kong': 'hk',
	Australia: 'au',
	Ireland: 'ie',
	India: 'in',
	Philippines: 'ph',
	[auCulture]: 'au',
	[usCulture]: 'us',
	[ukCulture]: 'gb',
	[hkCulture]: 'hk'
};

export const mobileNumberCountryCodesInISO = countryAndIsoCodesForMobileNumber.map((x) => x.isoCode);

export const toolsForMobile: PDFViewerTool[] = ['pager', 'spacer', 'zoom', 'zoomInOut'];
export const toolsForWeb: PDFViewerTool[] = [
	'pager',
	'spacer',
	'zoomInOut',
	'zoom',
	'selection',
	'spacer',
	'download',
	'print'
];

export const defaultMoneyValue = '0'; // Partners ask to handle money as whole number, so don't use '0.00'

export const colorPalette = [
	{ name: 'green', light: '#89C535', dark: '#328748' },
	{ name: 'orange', light: '#FDD835', dark: '#F9A825' },
	{ name: 'red', light: '#F68381', dark: '#E51E25' },
	{ name: 'blue', light: '#008AEC', dark: '#006CB8' }
];

export const clientUserType = 'Client';
export const partnerUserType = 'Partner';
export const documentTimeStampFormat = 'hh:mm a, dd MMM yyyy';
export const commentTimeStampFormat = 'dd/MM/yyyy, hh:mm aa';
export const eventDateFormat = 'EEEE, MMMM d';
export const eventSessionTimeFormat = 'h:mm a';

export const dateFormatFull = 'dd MMM yyyy';
export const dateFormatShort = 'dd MMM';
export const dateFormatMonthYear = 'MMM yy';
export const dateFormatMonthFullYear = 'MMM yyyy';
export const dateFormatForAU = 'dd/MM/yyyy';
export const dateFormatDisplay = 'dd MMM, yyyy';

export const redirectNotificationCodes = ['FinancialDocumentChanged', 'NewChatMessage', 'DocumentVaultChanged'];

// Modal appear time:
export const tenHoursInMilliseconds = 1000 * 60 * 60 * 10;
export const threeHoursInMilliseconds = 1000 * 60 * 60 * 3;

// Preference keys and related constants
export const maxPageShowUpTimes = 3;
export const preferenceKeys = {
	hasAppFeatureShown: 'hasAppFeatureShown',
	hasEventRegistered: 'hasEventRegistered',
	eventRegistrationShownCount: 'eventRegistrationShownCount',
	hasNotificationEnabled: 'hasNotificationEnabled',
	notificationPromptShownCount: 'notificationPromptShownCount'
};

export const investmentAccountTypes = {
	hub24: 'Hub24',
	other: 'Other'
};

// Contact names
export const kpgSharesContactName = 'Joyce AU';

// KPG Share Resources categories
export const resourceCategories = {
	resource: 'Resource',
	interview: 'Interview'
};

// Must match the BE constant: FinancialLockupType
export const lockupType = {
	lockup: 'Lockup',
	wip: 'Wip',
	debtor: 'Debtor'
};

export const careerPlanStatus = {
	InProgress: 'In Progress',
	Complete: 'Complete',
	NotDone: 'Not Done'
};
